const EVENT_LISTENERS_MODIFIER_NAME = 'eventListeners';

// Temporary workaround: remove when Reaxys adopts the new branding and Flyout 7+.
// Legacy Flyout keeps closed hover panels mounted, so Popper otherwise registers
// scroll listeners for every tooltip in large result lists.
export default function getHoverFlyoutModifiers(modifiers = []) {
  return [
    ...modifiers.filter(({ name }) => name !== EVENT_LISTENERS_MODIFIER_NAME),
    { name: EVENT_LISTENERS_MODIFIER_NAME, enabled: false },
  ];
}
